var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2-me-set-font-family-mixin.2"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2-me-set-font-family-mixin.2"
    },
    "bundlingPackage": "LearningCenterUI",
    "bundlingPackageVersion": "static-1.32969",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};